// 配置接口地址
export const api = {
    // 删除人脸名单
    peopleTrackDetails: '/vas/personnelControl/personnelSearching/peopleTrackDetails.json',
    // 查询区域树
    querydeviceByArea: '/vas/bayonet/querydeviceByArea.json',
    batchFileload: '/common/file/batchFileload.json',
    // 查询人脸
    peopleSearch: 'vas/personnelControl/personnelSearching/peopleSearch.json'
}
  